import { DEATH, DISABILITY, RETIREMENT } from './constants/dashboardTypes';

export const payoutTypes = [RETIREMENT, DISABILITY, DEATH];
export const payoutTypeDeathAndDisability = [DISABILITY, DEATH];
